export interface Volume {
  code: string
  name: string
  /** Minimo garantito di lezioni ("+X"). La somma dei minimi è 90 (quindi 70+ è vero). */
  lessons: string
  featured?: boolean
  description: string
  solves: string
  result: string
  value: string
}

export const volumes: Volume[] = [
  {
    code: '01',
    name: 'Vinyasa Flow Dinamico',
    lessons: '+30 lezioni',
    featured: true,
    description:
      'Lezioni di flusso energizzante. Transizioni fluide, progressioni intelligenti, puro movimento consapevole.',
    solves:
      'Sequenze che si interrompono, transizioni goffe tra le posizioni e classi che finiscono per assomigliarsi tutte.',
    result:
      'Flussi che scorrono dall’inizio alla fine e studenti che escono dalla classe pieni di energia.',
    value: '€47',
  },
  {
    code: '02',
    name: 'Hatha & Allineamento',
    lessons: '+12 lezioni',
    description:
      'Lezioni strutturate di yoga tradizionale. Fondamenta solide, allineamento preciso, autorità professionale garantita.',
    solves:
      'Allievi che eseguono le posizioni in modo scorretto e la difficoltà di spiegare l’allineamento in modo semplice.',
    result:
      'Posizioni sicure e ben allineate, e una guida chiara che trasmette autorità in sala.',
    value: '€47',
  },
  {
    code: '03',
    name: 'Yin & Yoga Rigenerativo',
    lessons: '+12 lezioni',
    description:
      'Pratiche di rilassamento profondo. Respiro, rilascio, integrazione. Il volume che più piace ai tuoi studenti.',
    solves:
      'Classi lente che diventano noiose, tempi di tenuta improvvisati e silenzi che non sai come riempire.',
    result:
      'Pratiche profonde e ben ritmate che lasciano gli studenti calmi, rilassati e con la voglia di tornare.',
    value: '€47',
  },
  {
    code: '04',
    name: 'Yoga Terapeutico & Posturale',
    lessons: '+12 lezioni',
    description:
      'Lezioni specializzate per schiena, postura e mobilità. Perfetto per clienti privati e gruppi di terza età.',
    solves:
      'L’insicurezza davanti ad allievi con mal di schiena, rigidità o limitazioni fisiche.',
    result:
      'Lezioni sicure e adattate che ti permettono di lavorare con clienti privati e gruppi senior con fiducia.',
    value: '€37',
  },
  {
    code: '05',
    name: 'Pranayama & Meditazione',
    lessons: '+12 lezioni',
    description:
      'Tecniche di respirazione e guide meditative. Approfondimento spirituale, calma del sistema nervoso, pratica olistica.',
    solves:
      'Non sapere come guidare il respiro o la meditazione senza sembrare rigida o poco preparata.',
    result:
      'Momenti di respiro e meditazione guidati con voce sicura, che danno profondità a ogni classe.',
    value: '€37',
  },
  {
    code: '06',
    name: "Classi d'Emergenza Pronte",
    lessons: '+12 lezioni',
    description:
      'Lezioni di backup per quando non hai tempo di pianificare. Il tuo salvavita nelle situazioni improvvise.',
    solves:
      'Imprevisti, sostituzioni dell’ultimo minuto e giornate in cui non hai avuto tempo di preparare nulla.',
    result:
      'Entri in sala sempre con una classe completa pronta, anche quando la settimana ti travolge.',
    value: '€27',
  },
]
